import { Modal } from "antd";
import React from "react";

export const TermsAndConditions = ({ open, onClose }) => {
  return (
    <Modal
      title="Terms of use"
      open={open}
      onCancel={onClose}
      onOk={onClose}
      footer={null}
      width={920}
      bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
    >
      <div className="p-6 max-w-4xl mx-auto text-gray-900 leading-relaxed">
        {/* <h1 className="text-4xl font-bold mb-6">Terms of Use</h1> */}
        <p className="mb-4">
          <strong>Effective date:</strong> 13/11/25
        </p>

        <p className="mb-6">
          These Terms form a contract between you and{" "}
          <strong>Quelld Ltd</strong> ("Quelld," "we," "us"). By using{" "}
          <strong>Quelld.ai</strong> (the "App") or{" "}
          <strong>Quelld.com</strong> (the "Site"), you agree to these Terms and
          our Privacy Policy.
        </p>

        {/* Section 1 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">
          1) Eligibility & Accounts
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>You must be 18+ and capable of forming a contract.</li>
          <li>
            Keep your credentials secure; you are responsible for all activity
            under your account.
          </li>
          <li>We may offer single sign-on (SSO) across the App and Site.</li>
        </ul>

        {/* Section 2 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">2) Roles and Services</h2>
        <p>Quelld supports two primary roles:</p>
        <ul className="list-disc pl-6 space-y-1 mt-2">
          <li>
            <strong>Service Providers</strong> list services (childcare,
            tutoring, home services) and accept bookings.
          </li>
          <li>
            <strong>Parents/Homeowners (Customers)</strong> browse and book
            services.
          </li>
        </ul>
        <p className="mt-3">
          Quelld provides a platform/marketplace and AI enabled organisational
          tools. Unless stated otherwise, Quelld is <strong>not</strong> a party
          to contracts between Customers and Service Providers.
        </p>

        {/* Section 3 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">
          3) Bookings, Payments & Cancellations
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            Bookings are facilitated via Trafft on the Site. Additional fee
            schedules may apply.
          </li>
          <li>
            Payments are processed by our payment processor; you authorise
            charges for fees and taxes.
          </li>
          <li>
            Cancellation, refund, and dispute terms are shown during booking and
            in Schedule B.
          </li>
        </ul>

        {/* Section 4 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">
          4) App Features (AI, Calendars, Co Parenting)
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            The App may include AI assisted features (email parsing, keyword
            onboarding, custody templates).
          </li>
          <li>
            Outputs may be imperfect. You are responsible for verifying
            schedules, communications, and actions.
          </li>
        </ul>

        {/* Section 5 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">5) Acceptable Use</h2>
        <p>You agree NOT to:</p>
        <ul className="list-disc pl-6 space-y-1 mt-2">
          <li>Break the law or infringe IP/privacy rights.</li>
          <li>
            Upload unlawful, harmful, or inappropriate content (including
            unauthorised childrens data).
          </li>
          <li>
            Reverse engineer, scrape, damage systems, or bypass access controls.
          </li>
          <li>Post fraudulent, biased, or retaliatory reviews.</li>
        </ul>
        <p className="mt-3">
          We may remove content or suspend accounts violating these Terms.
        </p>

        {/* Section 6 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">
          6) Intellectual Property
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Quelld owns all rights to the Site, App, and branding.</li>
          <li>
            You grant a worldwide, nonexclusive, royalty free licence to
            process your content for service operation.
          </li>
          <li>You must not use Quelld trademarks without permission.</li>
        </ul>

        {/* Section 7 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">7) Feedback</h2>
        <p>
          Submitting ideas or suggestions grants Quelld a worldwide, perpetual,
          irrevocable licence to use them without compensation.
        </p>

        {/* Section 8 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">8) Disclaimers</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Services are provided  oas is ? and  oas available. ?</li>
          <li>
            Marketplace listings and user content are provided by users;
            accuracy is not guaranteed.
          </li>
          <li>Quelld is not responsible for interactions between users.</li>
          <li>
            Quelld does not provide legal, medical, therapeutic, or professional
            advice.
          </li>
        </ul>

        {/* Section 9 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">
          9) Limitation of Liability
        </h2>
        <p>
          To the fullest extent permitted by law:
          <br />
             Quelld is not liable for indirect, incidental, special,
          consequential, or punitive damages.
          <br />
             Total liability is capped at <strong>A 100</strong> or the amount
          paid by you in the past 12 months.
        </p>

        {/* Section 10 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">10) Indemnity</h2>
        <p>
          You agree to defend, indemnify, and hold harmless Quelld and its
          affiliates from claims arising from your use of the services, your
          content, or your breach of these Terms.
        </p>

        {/* Section 11 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">11) Termination</h2>
        <p>
          You may stop using the services anytime. We may suspend or terminate
          access for violations or legal requirements. Certain provisions
          survive termination.
        </p>

        {/* Section 12 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">
          12) Changes to the Services or Terms
        </h2>
        <p>
          We may modify features or terms. Material changes will be notified by
          email or inapp. Continued use means acceptance of updated Terms.
        </p>

        {/* Section 13 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">
          13) Governing Law & Disputes
        </h2>
        <p>
          Governed by the laws of England and Wales. Courts of England & Wales
          have jurisdiction, except where local consumer protections apply.
          Parties must attempt informal resolution before litigation.
        </p>

        {/* Section 14 */}
        <h2 className="text-2xl font-bold mt-8 mb-3">14) Contact</h2>
        <p>
          <strong>Quelld Ltd</strong>, 128 City Road, London, EC1V 2NX
        </p>

        {/* Schedule A */}
        <h2 className="text-2xl font-bold mt-12 mb-3">
          Schedule A App Specific Terms (Quelld.ai)
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>SSO & linked accounts across App and Site.</li>
          <li>
            Connected data sources may be processed only for enabled features.
          </li>
          <li>
            Custody templates (e.g., 5225) are for convenience only.
          </li>
          <li>
            You control notification settings; network/SMS charges may apply.
          </li>
        </ul>

        {/* Schedule B */}
        <h2 className="text-2xl font-bold mt-12 mb-3">
          Schedule B Marketplace & Bookings (Quelld.com via Trafft)
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            Providers must offer accurate listings, pricing, and required
            checks.
          </li>
          <li>Customers must review listings and comply with local laws.</li>
          <li>Fees and payouts handled by the payment processor.</li>
          <li>Cancellations & refunds follow displayed policies.</li>
          <li>Reviews must be honest; moderation may occur.</li>
          <li>Disputes should begin through platform messaging.</li>
        </ul>

        {/* Schedule C */}
        <h2 className="text-2xl font-bold mt-12 mb-3">
          Schedule C SubProcessors
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Hosting & infrastructure: [e.g., AWS, Vercel]</li>
          <li>
            AI/ML processing: [e.g., OpenAI, Anthropic] used to process user
            authorised content for assistive features; no training on your data
            beyond providing the service.
          </li>
          <li>Email & notifications: [e.g., SendGrid/Postmark]</li>
          <li>Analytics: [e.g., Google Analytics]</li>
          <li>Bookings: Trafft (white label by ChangeF)</li>
          <li>Payments: [e.g., Stripe]</li>
        </ul>

        {/* Schedule D */}
        <h2 className="text-2xl font-bold mt-10 mb-3">
          Schedule D Cookie Notice (Summary Boilerplate)
        </h2>

        <p className="mb-3">
          We use cookies and similar technologies to support and improve the
          services.
        </p>

        <h3 className="text-xl font-semibold mt-4 mb-2">Categories</h3>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Essential:</strong> authentication, SSO, security, load
            balancing.
          </li>
          <li>
            <strong>Functional:</strong> remember preferences (e.g., role,
            locale).
          </li>
          <li>
            <strong>Analytics:</strong> measure usage and performance.
          </li>
          <li>
            <strong>Marketing:</strong> measure campaigns and show relevant ads
            (where used).
          </li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-2">Your Choices</h3>
        <p>
          Use the on-site banner to accept or manage categories (except
          essential). You can withdraw consent anytime in Cookie Settings.
        </p>

        <h3 className="text-xl font-semibold mt-6 mb-2">Key Cookies</h3>
        <ul className="list-disc pl-6 space-y-1 mb-6">
          <li>
            <strong>Session/SSO tokens (first party)</strong> keep you
            signed in.
          </li>
          <li>
            <strong>Trafft/Stripe cookies (third party)</strong> bookings
            and payments.
          </li>
          <li>
            <strong>Analytics cookies</strong> understand usage trends.
          </li>
        </ul>
      </div>
    </Modal>
  );
};
